import React, { useState } from 'react';
import Modal from './Modal';
import './styles/components.css';

const DeleteButton = ({ item, onDelete }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setFeedback(null);
    await onDelete(success => {
      setLoading(false);
      setFeedback(success ? 'Eliminado correctamente' : 'Error al eliminar');
      if (success) {
        setTimeout(() => {
          setOpen(false);
          setFeedback(null);
        }, 1000);
      }
    });
  };

  return (
    <>
      <button className="delete-btn" onClick={() => setOpen(true)}>
        Eliminar
      </button>
      {open && (
        <Modal
          title="Confirmar Eliminación"
          onClose={() => setOpen(false)}
          actions={
            <div className="modal-actions">
              <button
                className="delete-btn"
                onClick={handleDelete}
                disabled={loading}
                style={{ marginRight: 8 }}
              >
                {loading ? 'Eliminando...' : 'Eliminar'}
              </button>
              <button type="button" className="close-btn" onClick={() => setOpen(false)}>
                Cerrar
              </button>
            </div>
          }
        >
          <p>
            ¿Está seguro de que desea eliminar el objeto '{item.nombre || item.id_parametro}'?
          </p>
          {feedback && <div style={{ marginTop: 10 }}>{feedback}</div>}
        </Modal>
      )}
    </>
  );
};

export default DeleteButton;
